import React, { useMemo } from "react";
import { baseUrlImg } from "../../config/api";

function formatDate(dateString) {
  if (!dateString) return "-";

  const date = new Date(dateString);

  return date.toLocaleString("it-IT", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
}

const EpipoliTicket = ({ arr }) => {
  const receiptData = useMemo(() => {
    if (!arr.receipt) return {};

    try {
      const cleanJson = arr.receipt
        .replace(/\\\n/g, "\\\n")
        .replace(/\\\r/g, "\\\r")
        .replace(/\\\t/g, "\\\t")
        .replace(/[\u0000-\u001F]+/g, "");

      return JSON.parse(cleanJson);
    } catch (err) {
      console.error("Invalid JSON receipt:", err);
      return {};
    }
  }, [arr.receipt]);

  const codiceSicurezza = useMemo(() => {
    if (receiptData.cc_codice_sicurezza) {
      return receiptData.cc_codice_sicurezza;
    }

    const item = receiptData.cardDetails?.item;

    if (!item) {
      return null;
    }

    if (Array.isArray(item)) {
      return (
        item.find(
          (entry) => entry?.key === "cc_codice_sicurezza"
        )?.value || null
      );
    }

    if (
      typeof item === "object" &&
      item.key === "cc_codice_sicurezza"
    ) {
      return item.value || null;
    }

    return null;
  }, [receiptData]);

  const blobUrl = useMemo(() => {
    if (!receiptData.pdfBase64) return null;

    try {
      const byteCharacters = atob(receiptData.pdfBase64);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      const blob = new Blob([byteArray], {
        type: "application/pdf",
      });

      return URL.createObjectURL(blob);
    } catch {
      return null;
    }
  }, [receiptData.pdfBase64]);

  return (
    <div>
      <div className="json_spedizionepro">
        <div
          className="d-flex justify-content-center mb-4"
          style={{ border: "unset" }}
        >
          <img
            src={`${baseUrlImg}/${arr.logo}`}
            alt="service logo"
            height={40}
          />
        </div>

        <div style={{ paddingTop: 10 }}>
          Data di creazione:{" "}
          <span>{formatDate(arr.created_at)}</span>
        </div>

        <div style={{ paddingTop: 10 }}>
          Data di scadenza:{" "}
          <span>{formatDate(receiptData.expiresAt)}</span>
        </div>

        <div style={{ paddingTop: 10 }}>
          Card Code:{" "}
          <span>{receiptData.cardCode || "-"}</span>
        </div>

        {codiceSicurezza && (
          <div style={{ paddingTop: 10 }}>
            Codice Sicurezza:{" "}
            <span>{codiceSicurezza}</span>
          </div>
        )}

        <div style={{ paddingTop: 10 }}>
          Negozio ID:{" "}
          <span>{receiptData.user_id || "-"}</span>
        </div>
      </div>

      {/*
      {receiptData.cardUrl && (
        <div
          style={{
            width: "100%",
            wordBreak: "break-word",
          }}
        >
          <div
            style={{
              marginBottom: "5px",
              marginTop: "10px",
              fontWeight: "400",
            }}
          >
            Per l'attivazione della gift card clicca il link qui sotto:
          </div>

          <a
            href={receiptData.cardUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#3b82f6",
              textDecoration: "underline",
              display: "inline-block",
            }}
          >
            {receiptData.cardUrl}
          </a>
        </div>
      )}
      */}

      {blobUrl && (
        <div
          className="receipt-data"
          style={{
            width: "100%",
            marginTop: "10px",
          }}
        >
          <a
            href={blobUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#3b82f6",
              textDecoration: "underline",
              display: "inline-block",
            }}
          >
            CLICCA PER LA RICEVUTA
          </a>
        </div>
      )}
    </div>
  );
};

export default EpipoliTicket;